import { render, staticRenderFns } from "./ViewerSvg.vue?vue&type=template&id=440baaf6"
import script from "./ViewerSvg.vue?vue&type=script&lang=js"
export * from "./ViewerSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports